/**
 * 格式化工具函数
 */

/**
 * 格式化日期时间
 * @param {number|string|Date} value - 时间戳或日期字符串
 * @param {string} format - 格式字符串，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期字符串
 */
export function formatDateTime(value, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!value) return ''
  
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return ''
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

/**
 * 格式化日期（YYYY-MM-DD）
 * @param {number|string|Date} value
 * @returns {string}
 */
export function formatDate(value) {
  return formatDateTime(value, 'YYYY-MM-DD')
}

/**
 * 格式化时间（HH:mm:ss）
 * @param {number|string|Date} value
 * @returns {string}
 */
export function formatTime(value) {
  return formatDateTime(value, 'HH:mm:ss')
}

/**
 * 格式化相对时间（如：1分钟前、2小时前）
 * @param {number|string|Date} value
 * @param {Function} t - i18n翻译函数
 * @returns {string}
 */
export function formatTimeAgo(value, t = null) {
  if (!value) return ''
  
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return ''
  
  const now = Date.now()
  const diff = now - date.getTime()
  const seconds = Math.floor(diff / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  
  const translate = t || ((key, params) => key)
  
  if (seconds < 60) {
    return translate('global.time.sec', { time: seconds })
  } else if (minutes < 60) {
    return translate('global.time.min', { time: minutes })
  } else if (hours < 24) {
    return translate('global.time.hor', { time: hours })
  } else {
    return formatDateTime(value)
  }
}

/**
 * 格式化文件大小
 * @param {number} bytes - 字节数
 * @param {number} decimals - 小数位数
 * @returns {string}
 */
export function formatFileSize(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'
  
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * 格式化数字（添加千分位）
 * @param {number} value
 * @returns {string}
 */
export function formatNumber(value) {
  if (value == null) return ''
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

